import React from 'react';
import { Construction } from 'lucide-react';

export default function ComingSoonBanner({ title = 'En cours de construction', message, compact = false }) {
  return (
    <div
      className={`relative overflow-hidden rounded-sm border border-secondary/25 bg-secondary/10 backdrop-blur ${
        compact ? 'px-4 py-3' : 'px-5 py-5 md:px-6 md:py-6'
      }`}
      role="status"
      data-testid="coming-soon-banner"
    >
      <div className="absolute inset-0 bg-gradient-to-r from-secondary/5 via-transparent to-secondary/5 pointer-events-none" />
      <div className="relative flex items-start gap-3 md:gap-4">
        <div className="shrink-0 w-10 h-10 rounded-full bg-secondary/15 border border-secondary/40 flex items-center justify-center">
          <Construction className="w-5 h-5 text-secondary" />
        </div>
        <div className="flex-1 min-w-0">
          <p className={`font-heading font-semibold text-secondary ${compact ? 'text-sm' : 'text-base md:text-lg'}`}>
            {title}
          </p>
          {message && (
            <p className={`text-secondary/80 mt-0.5 ${compact ? 'text-xs' : 'text-sm md:text-[15px] leading-relaxed'}`}>
              {message}
            </p>
          )}
        </div>
      </div>
    </div>
  );
}
